export const colorBlockStlye = color => {
  return {
    display: 'block',
    padding: '8px 14px',
    margin: '8px 0',
    backgroundColor: color,
    border: '1px solid #696969',
  };
};

export const editingColorBlockStlye = color => {
  return {
    display: 'inline-block',
    padding: '8px 14px',
    width: '48%',
    minWidth: '120px',
    margin: '8px 4% 8px 0',
    backgroundColor: color,
    border: '1px solid #696969',
  };
};
export const setBackGroundColor = color => {
  return {
    backgroundColor: color,
  };
};

export const editingStlyeWithoutBackGround = color => {
  return {
    display: 'inline-block',
    padding: '8px 14px',
    width: '48%',
    minWidth: '120px',
    margin: '8px 4% 8px 0',
    border: '1px solid #696969',
  };
};

export const InputStlye = {
  display: 'inline-block',
  padding: '8px 14px',
  width: '48%',
  margin: '8px 0',
  border: '1px solid #696969',
};
export const SelectStyle = {
  display: 'inline-block',
  padding: '8px 14px',
  width: '100%',
  margin: '8px 0',
  border: '1px solid #696969',
};

export const avatarStyle = {
  margin: '4px 8px',
  padding: '5px 4px',
  display: 'inline-block',
};

export const avatarShadowStyle = {
  margin: '4px 8px',
  padding: '5px 4px',
  display: 'inline-block',
  boxShadow: '1px 1px 7px 0px rgba(219,219,219,1)',
  borderRadius: '8px',
};
